import React from "react";
import Markdown from "../utility/markdown";
import Prose from "../utility/prose";
import { GatsbyImage } from "gatsby-plugin-image"

const Cards = ({cards}) => {
    switch (cards.style) {
        case "three column":
            return (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">
                    {cards.cards.map((card) => (
                        <div key={card.id} className="p-4 text-sm text-stone-700 dark:text-stone-300" role="alert">
                                {card.image !== null ? (
                                    <GatsbyImage className="min-w-full w-auto -ml-4 -mt-4 -mr-4 mb-8 shadow-xl rounded-3xl" image={card.image.localFile.childImageSharp.gatsbyImageData} alt={card.image.alternativeText} />
                                ) : (<></>)}
                            <Prose>
                                <h2 className="leading-none">{card.title}</h2>
                            </Prose>
                            <Markdown className="leading-none" body={card.content.data.content}></Markdown>
                            <div className="flex flex-start flex-wrap text-center">
                                    {card.leftButtonTitle !== null && card.leftButtonTitle !== "" ? (
                                        <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" href={card.leftButtonUrl}>{card.leftButtonTitle}</a>
                                    ) : (<></>)}
                                    {card.centerButtonTitle !== null && card.centerButtonTitle !== "" ? (
                                        <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" href={card.centerButtonUrl}>{card.centerButtonTitle}</a>
                                    ) : (<></>)}
                                    {card.rightButtonTitle !== null && card.rightButtonTitle !== "" ? (
                                        <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 px-4 py-2 mb-2 rounded-full leading-none" href={card.rightButtonUrl}>{card.rightButtonTitle}</a>
                                    ) : (<></>)}
                            </div>
                        </div>
                    ))}
                </div>
            )
        case "two column":
            return (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-14">
                    {cards.cards.map((card) => (
                        <div key={card.id} className="p-5 text-sm text-stone-700 dark:text-stone-300" role="alert">
                                {card.image !== null ? (
                                    <GatsbyImage className="min-w-full w-auto -ml-4 -mt-4 -mr-4 mb-8 shadow-xl rounded-3xl" image={card.image.localFile.childImageSharp.gatsbyImageData} alt={card.image.alternativeText} />
                                ) : (<></>)}
                            <Prose>
                                <h2 className="leading-none">{card.title}</h2>
                            </Prose>
                            <Markdown className="leading-none" body={card.content.data.content}></Markdown>
                            <div className="flex flex-start flex-wrap text-center">
                                    {card.leftButtonTitle !== null && card.leftButtonTitle !== "" ? (
                                        <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" href={card.leftButtonUrl}>{card.leftButtonTitle}</a>
                                    ) : (<></>)}
                                    {card.centerButtonTitle !== null && card.centerButtonTitle !== "" ? (
                                        <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" href={card.centerButtonUrl}>{card.centerButtonTitle}</a>
                                    ) : (<></>)}
                                    {card.rightButtonTitle !== null && card.rightButtonTitle !== "" ? (
                                        <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 px-4 py-2 mb-2 rounded-full leading-none" href={card.rightButtonUrl}>{card.rightButtonTitle}</a>
                                    ) : (<></>)}
                            </div>
                        </div>
                    ))}
                </div>
            )
        default: //full width
            return (
                <div className="grid grid-cols-1 gap-4 mb-14">
                    {cards.cards.map((card) => (
                        <div key={card.id} className="flex rounded-3xl p-4 text-sm text-stone-700 dark:text-stone-300" role="alert">
                                {card.image !== null ? (
                                <div className="w-1/3 h-full mr-8">
                                    <GatsbyImage className="min-w-full h-auto w-auto -ml-4 -mt-4 mr-8 -mb-4 shadow-xl rounded-3xl" image={card.image.localFile.childImageSharp.gatsbyImageData} alt={card.image.alternativeText} />
                                </div>
                                ) : (<></>)}
                                <div className={`${card.image !== null ?'w-2/3':''}`}>
                                <div className="pt-2">
                                    <Prose>
                                        <h2 className="leading-none">{card.title}</h2>
                                    </Prose>
                                </div>
                                <Markdown className="leading-none" body={card.content.data.content}></Markdown>
                                <div className="flex flex-start flex-wrap text-center">
                                        {card.leftButtonTitle !== null && card.leftButtonTitle !== "" ? (
                                            <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" href={card.leftButtonUrl}>{card.leftButtonTitle}</a>
                                        ) : (<></>)}
                                        {card.centerButtonTitle !== null && card.centerButtonTitle !== "" ? (
                                            <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" href={card.centerButtonUrl}>{card.centerButtonTitle}</a>
                                        ) : (<></>)}
                                        {card.rightButtonTitle !== null && card.rightButtonTitle !== "" ? (
                                            <a target="_blank" rel="noopener noreferrer" className="bg-stone-200 hover:bg-stone-300 dark:bg-stone-800 hover:dark:bg-stone-900 px-4 py-2 mb-2 rounded-full leading-none" href={card.rightButtonUrl}>{card.rightButtonTitle}</a>
                                        ) : (<></>)}
                                </div>
                                </div>
                        </div>
                    ))}
                </div>
            )
    }
}

export default Cards